import {Component, ChangeDetectionStrategy} from '@angular/core';

import {Modal} from "@softline/ui-core";
import {Anwender} from "../../types/warenuebernahme";

import { TranslatePipe } from '@softline/ui-core';
@Component({
    selector: 'soft-warenuebernahme-sperren-bestaetigen-dialog',
    imports: [
    TranslatePipe
  ],
    templateUrl: './warenuebernahme-sperren-bestaetigen-dialog.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./warenuebernahme-sperren-bestaetigen-dialog.component.css']
})
export class WarenuebernahmeSperrenBestaetigenDialogComponent implements Modal<boolean> {

  close!: (result: boolean) => void;

  exzess!: Anwender;

  registerCloseHandler(handler: (result: boolean) => void): void {
    this.close = handler;
  }
}
